<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form @keyup.enter.native="searchQuery" layout="inline">
        <a-row :gutter="24"></a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator" v-if="!disabled">
      <a-button @click="handleAdd" icon="plus" type="primary">新增</a-button>
      <!-- 高级查询区域-->
      <j-super-query
        :fieldList="superFieldList"
        @handleSuperQuery="handleSuperQuery"
        ref="superQueryModal"
      ></j-super-query>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item @click="batchDel" key="1"> <a-icon type="delete" />删除 </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <a-table
        :columns="columns"
        :customRow="customRowRender"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :scroll="{ x: true }"
        @change="handleTableChange"
        bordered
        class="j-table-force-nowrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <template slot="previewSlot" slot-scope="text, record">
          <a-button @click="previewFile(record.pictureObjId)" size="small" type="link" v-if="record.pictureObjId">{{
            text
          }}</a-button>
          <span v-else>{{ text }}</span>
        </template>

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无图片</span>
          <img
            :src="getImgView(text)"
            alt
            height="25px"
            style="max-width:80px;font-size: 12px;font-style: italic;"
            v-else
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无文件</span>
          <a-button :ghost="true" @click="downloadFile(text)" icon="download" size="small" type="primary" v-else
            >下载</a-button
          >
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)" v-if="!disabled">编辑</a>
          <a-divider type="vertical" v-if="!disabled" />
          <a @click="handleDetail(record)">详情</a>
          <a-divider type="vertical" v-if="!disabled" />
          <a-popconfirm @confirm="() => handleDelete(record.id)" title="确定删除吗?" v-if="!disabled">
            <a>删除</a>
          </a-popconfirm>
        </span>
      </a-table>
    </div>

    <dev-docs-modal :deviceData="deviceData" @ok="modalFormOk" ref="modalForm"></dev-docs-modal>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import DevDocsModal from './modules/DevDocsModal'
import { filterDictTextByCache } from '@/components/dict/JDictSelectUtil'

export default {
  name: 'DevDocsList',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    DevDocsModal
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    deviceData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      description: '设备手册管理页面',
      // 表头
      columns: [
        //   {
        //     title: '设备名称',
        //     align: 'center',
        //     dataIndex: 'devName'
        //   },
        {
          title: '文档名称',
          align: 'center',
          dataIndex: 'docName',
          scopedSlots: { customRender: 'previewSlot' }
        },
        {
          title: '文档类型',
          align: 'center',
          dataIndex: 'docType',
          customRender: text => {
            // 字典值替换通用方法
            return filterDictTextByCache('dev_docs_type', text)
          }
        },
        {
          title: '文档说明',
          align: 'center',
          dataIndex: 'docDesc'
        },
        {
          title: '文档对象',
          align: 'center',
          dataIndex: 'pictureObjId',
          scopedSlots: { customRender: 'fileSlot' }
        },

        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 147,
          scopedSlots: { customRender: 'action' }
        }
      ],
      url: {
        list: '/device/devDocs/list',
        delete: '/device/devDocs/delete',
        deleteBatch: '/device/devDocs/deleteBatch',
        exportXlsUrl: '/device/devDocs/exportXls',
        importExcelUrl: 'device/devDocs/importExcel'
      },
      dictOptions: {},
      superFieldList: [],
      disableMixinCreated: true
    }
  },
  created() {
    if (this.deviceData.id || this.deviceData.devTypeId) {
      this.queryParam = {
        superQueryMatchType: 'or',
        superQueryParams: encodeURI(
          JSON.stringify([
            { rule: 'eq', type: 'string', val: this.deviceData.id, field: 'devId' },
            { rule: 'eq', type: 'string', val: this.deviceData.devTypeId, field: 'devModelId' }
          ])
        )
      }
    }
    this.loadData()

    this.getSuperFieldList()
  },
  computed: {
    importExcelUrl: function() {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    }
  },
  methods: {
    previewFile(fileUrl) {
      const buf = Buffer.from(fileUrl)
      let url = window._CONFIG['onlinePreviewDomainURL'] + '?url=' + encodeURIComponent(buf.toString('base64'))
      window.open(url, '_blank')
    },
    initDictConfig() {},
    getSuperFieldList() {
      let fieldList = []
      fieldList.push({ type: 'int', value: 'devId', text: '设备ID' })
      fieldList.push({ type: 'string', value: 'docName', text: '文档名称' })
      fieldList.push({ type: 'string', value: 'docType', text: '文档类型' })
      fieldList.push({ type: 'string', value: 'docDesc', text: '文档说明' })
      fieldList.push({ type: 'string', value: 'pictureObjId', text: '文档对象' })

      this.superFieldList = fieldList
    }
  }
}
</script>
<style scoped>

@import '~@assets/less/common.less';

</style>
